import { render, staticRenderFns } from "./ChoiceEvaluateModel.vue?vue&type=template&id=20bbe7c3&scoped=true"
import script from "./ChoiceEvaluateModel.vue?vue&type=script&lang=js"
export * from "./ChoiceEvaluateModel.vue?vue&type=script&lang=js"
import style0 from "./ChoiceEvaluateModel.vue?vue&type=style&index=0&id=20bbe7c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bbe7c3",
  null
  
)

export default component.exports